import styled from 'styled-components';

export const LinkToPaymentMethodsRoot = styled.div`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
`;
